import { CONTAINER_DEFAULTS } from '@typedream/components';
import { ContainerElement, DreamBlock } from '@typedream/core';
import { PlatePluginComponent, TRenderElementProps } from '@udecode/plate-core';
import { ComponentType } from 'react';
import { createTElementPluginFactory } from '../../plate';
import { ELEMENT_CONTAINER } from '../../pluginKeys';
import { withDropTarget } from '../../plugins/dnd';
import { ContainerElementEditor } from './components/ContainerElement';
import { createSyncedContainerPlugin } from './createSyncedContainerPlugin';
import { ContainerElementPluginOptions } from './types';

export const createContainerPlugin = createTElementPluginFactory({
  key: ELEMENT_CONTAINER,
  component: withDropTarget(ContainerElementEditor as ComponentType<TRenderElementProps>),
  options: {
    isDreamBlock: true,
    isSelectable: true,
    isResizable: (element: DreamBlock) => {
      const directions: Array<'s' | 'w' | 'e'> = ['w', 'e'];
      if ((element as ContainerElement).height) {
        directions.push('s');
      }
      return { directions };
    },
    isDraggable: true,
    isDroppable: true,
    meta: {
      img: '/canvas/images/container.png',
      title: 'Container',
      subtitle: 'A container that can hold multiple items',
      keywords: ['container', 'section', 'box', 'card', 'block'],
    },
    format: {
      formatType: 'block',
      blurAfterSet: true,
      insertNode: {
        type: ELEMENT_CONTAINER,
        background: 'default',
        align: 'align_center',
        overflow: CONTAINER_DEFAULTS.overflow,
        children: [
          {
            text: '',
          },
        ],
      } as DreamBlock,
      turnInto: [],
      focusableWhenEmpty: false,
      validProperties: [
        'height',
        'width',
        'width_max',
        'align',
        'vertical_align',
        'style',
        'background',
        'backgroundImage',
        'backgroundDarken',
        'backgroundVideo',
        'keep_aspect_ratio',
        'mobile_hide',
        'desktop_hide',
        'url',
        'internal_link',
        'page_id',
        'open_in_new_tab',
        'animation',
        'padding',
        'margin',
        'overflow',
        'border_radius',
        'box_shadow',
        // properties for synced container
        'transclusion_enabled',
        'transclusion_reference_id',
        'transclusion_updated_at',
        'name',
      ],
    },
    isTransclusionEnabled: false,
    getTransclusionReferences: () => {
      throw Error('getTransclusionReferences is not implemented');
    },
    createTransclusionReference: () => {
      throw Error('setSyncedReference is not implemented');
    },
    onEditSyncedReference: () => {
      throw Error('onEditSyncedReference is not implemented');
    },
  },
  plugins: [createSyncedContainerPlugin()],
} as {
  key: DreamBlock['type'];
  component: PlatePluginComponent;
  options: ContainerElementPluginOptions;
});
